import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const ConfirmationDialog = ({ 
    showConfirmation, 
    setShowConfirmation, 
    handleReturn, 
    loading, 
    language 
}) => {
    if (!showConfirmation) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
                <h3 className="text-lg font-medium mb-4">
                    {language === 'ar' 
                        ? 'هل أنت متأكد من إرجاع هذا الطلب؟' 
                        : 'Are you sure you want to return this order?'}
                </h3>
                <div className="flex justify-end space-x-2 rtl:space-x-reverse">
                    <button
                        onClick={() => setShowConfirmation(false)}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                    >
                        {language === 'ar' ? 'إلغاء' : 'Cancel'}
                    </button>
                    <button
                        onClick={handleReturn}
                        disabled={loading}
                        className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50"
                    >
                        {loading ? (
                            <FaSpinner className="animate-spin h-5 w-5" />
                        ) : (
                            language === 'ar' ? 'تأكيد' : 'Confirm'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationDialog;
